import 'babel-polyfill';
import Router from './router';
import ReactDOM from 'react-dom';
import React from 'react';
import './main.scss';
import './util';
import './api_adapter';
import './init-srp6';
import './polyfills';
import './srp/thinbus-srp6a-sha256-versioned.js';
import { assign } from 'lodash';

window.settings = window.settings || {};
window.com = window.com || {};
window.com.rooxteam = window.com.rooxteam || {};
window.com.rooxteam.widgets = window.com.rooxteam.widgets || {};

if (process.env.NODE_ENV !== "development") {
  function noop() {
  }

  console.log = noop;
  console.warn = noop;
  console.error = noop;
  console.action = noop;
}
console.log('DEV node v14.19.0')

// Точка входа в виджет
function Login(moduleId, moduleBaseUrl) {
  this.moduleId = moduleId;
  this.widgetId = '#widget' + moduleId;
  //*******************************
  // get registerUrl
  this.registerUrl = "https://www.zenit.ru/";
  this.recoverUrl = "/sso/auth/start-password-recovery";
  if (typeof gadgets.config.get('com.rooxteam.config')['LOGIN'] != 'undefined' && typeof gadgets.config.get('com.rooxteam.config')['LOGIN'].registerUrl != 'undefined') {
    this.registerUrl = gadgets.config.get('com.rooxteam.config')['LOGIN'].registerUrl;
  }
  if (typeof gadgets.config.get('com.rooxteam.config')['LOGIN'] != 'undefined' && typeof gadgets.config.get('com.rooxteam.config')['LOGIN'].recoverUrl != 'undefined') {
    this.recoverUrl = gadgets.config.get('com.rooxteam.config')['LOGIN'].recoverUrl;
  }
  //*******************************

  //*******************************
  // get isSRP
  this.isSRP = true;
  if (typeof gadgets.config.get('com.rooxteam.config')['LOGIN'] != 'undefined' && typeof gadgets.config.get('com.rooxteam.config')['LOGIN']['auth_with_challenge'] != 'undefined') {
    this.isSRP = (gadgets.config.get('com.rooxteam.config')['LOGIN']['auth_with_challenge'] == 'true');
  }
  //*******************************

  // Первоначальные установки получаемые с сервера
  var prefs = new gadgets.Prefs(moduleId);
  var gPrefs = gadgets.util.unescapeString(prefs.getString("inputData"));
  this.prefs = JSON.parse(gPrefs);
  // поддержка logout_reason
  if (typeof prefs.getString("logout_reason") !== 'undefined' && (prefs.getString("logout_reason") === 'idle_timeout' || prefs.getString("logout_reason") === 'session_timeout')) {
    this.prefs.view.logoutReason = prefs.getString("logout_reason");
  }
  var self = this;
  // сохраняем корневой путь
  if (typeof moduleBaseUrl == 'undefined' || moduleBaseUrl === ".") {
    this.widgetBaseUrl = "./";
  } else {
    this.widgetBaseUrl = moduleBaseUrl;
  }
  // путь до изображений
  this.widgetImagesUrl = this.widgetBaseUrl + '/img/';
  // также сохраняем контекст в адаптере
  apiAdapter.context = self;
  // устанвливаем config srp
  if (typeof srp_prefs == 'undefined') {
    srp_prefs = {
      "n": "11144252439149533417835749556168991736939157778924947037200268358613863350040339017097790259154750906072491181606044774215413467851989724116331597513345603",
      "g": "2",
      "k": "b7867f1299da8cc24ab93e08986ebc4d6a478ad0",
      "h": "SHA256"
    };
  }
  apiAdapter.setSRPConfig(srp_prefs);
  ReactDOM.render(React.createElement(Router, assign({
    "context": self
  }, self.prefs)), document.getElementById('widget' + moduleId));
  var target = apiAdapter.url.replace('sso/auth/login-widget-router', '') !== 'https://i.zenit.ru' ? '*' : apiAdapter.url;
  window.top.postMessage('{"comrooxteampubsubid":"com.rooxteam.login.loaded","args":[]}', target);
}
Login.prototype = {}; // end prototype
com.rooxteam.widgets.Login = Login;
